module.exports = __webpack_public_path__ + "static/media/comment-check.aa050f94.svg";